import client from "../libs/HttpClient";

class ContactUsService {
  static addContactUs(request) {
    return client.post(`/contact-details`, request, {});
  }
}

export { ContactUsService };
